import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "fieldWrapper field" }
const _hoisted_2 = { style: {"display":"flex"} }
const _hoisted_3 = {
  key: 0,
  class: "label"
}
const _hoisted_4 = { class: "control has-icons-left" }
const _hoisted_5 = ["disabled", "placeholder"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "icon is-small is-left" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calendar" })
], -1)

import { ref, onMounted } from "vue";

import { timestampToYYYYMMDD, YYYYMMDDToTimestamp } from "@/core/utils"

import 'thedatepicker'; // Types

export default /*#__PURE__*/_defineComponent({
  __name: 'FormDateField',
  props: {
    modelValue: null,
    label: null,
    validator: null,
    validationId: null,
    placeholder: null,
    isDisabled: { type: Boolean },
    past: { type: Boolean },
    future: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as {
  modelValue?: number|string|Date,
  label?: string,
  validator?: (fieldId: any, val: any) => boolean,
  validationId?: string,
  placeholder?: string,
  isDisabled?: boolean,
  past?: boolean,
  future?: boolean,
}

require('thedatepicker/dist/the-datepicker.js'); // Implementation



// The input element where the form field's value will be bound
const inputElem = ref<any>(null);

// Event for two-way binding


const utcToLocal = (d: Date) => {
  return new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
}

const localToUtc = (d: Date) => {
  return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
}

// Enable calendar
onMounted(()=>{
  const datepicker = new (window as any).TheDatepicker.Datepicker(inputElem.value) as TheDatepicker.Datepicker;

  datepicker.options.setInputFormat("m/d/Y");

  const today = utcToLocal(new Date());

  if (props.past) {
    datepicker.options.setMaxDate(today);
  } else if (props.future) {
    datepicker.options.setMinDate(today);
  }

  // Set initial value
  if (props.modelValue) {
    datepicker.selectDate(utcToLocal(new Date(props.modelValue)));
  }

  // Emit on date change
  datepicker.options.onSelect((event,day,prevDay) => {
    if (!day) {
      emit("update:modelValue", null);
      return true;
    }

    // Truncate to day, and convert to UTC
    const d = localToUtc(day.getDate());

    // Preserve the original type of the bound value
    if (!props.modelValue || props.modelValue instanceof Date) {
      emit("update:modelValue", d);
    }
    else if (typeof props.modelValue == "number") {
      // Unix timestamp
      emit("update:modelValue", d.getTime());
    }
    else if (typeof props.modelValue == "string") {
      emit("update:modelValue", timestampToYYYYMMDD(d.getTime()));
    }

    return true;
  });

  datepicker.render();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.label)
        ? (_openBlock(), _createElementBlock("label", _hoisted_3, _toDisplayString(__props.label), 1))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "top")
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("input", {
        ref_key: "inputElem",
        ref: inputElem,
        class: _normalizeClass(["input", { 'is-danger': __props.validator ? !__props.validator(__props.validationId ? __props.validationId : this, __props.modelValue) : false }]),
        type: "text",
        disabled: __props.isDisabled,
        placeholder: __props.placeholder
      }, null, 10, _hoisted_5),
      _hoisted_6
    ])
  ]))
}
}

})